import { observer } from 'mobx-react';

import SteppedComponent from 'js/components/pages/SteppedComponent';
import analytics from 'js/services/Analytics';
import { lightGrey1Color } from 'js/config/style';
import { isPhoneNumber } from 'js/services/Regex';

import AppUser from 'js/stores/AppUser';
import CheckoutPageState from 'js/stores/pages/CheckoutPageState';

import DropOffDetails from './DropOffDetails';
import DropOffDetailsV2 from './DropOffDetailsV2';
import PaymentMethod from './PaymentMethod';
import ReviewOrder from './ReviewOrder';
import SignUpSignIn from './SignUpSignIn';
import UserInfo from './UserInfo';
import AppState from "js/stores/AppState";

@observer
export default class CheckoutPage extends SteppedComponent {
  pageName = 'CheckoutPage';
  trackingName = 'BP_checkout_item';
  pageColor = lightGrey1Color;
  orderReviewed = false;

  bootstrap = () => this.page.load();
  pageEvent = () => { /*analytics.page('CA_viewed checkout page')*/ };

  page = CheckoutPageState.create({
    alias: this.props.alias,
  }).setSteps(this, 'checkout-page', [
    {
      name: 'buyer-guide',
      label: 'Buyer Guide',
      component: DropOffDetailsV2,
      onEnter: (page, step) => { /* analytics.page('CA_viewed buyer guide') */ },
    },
    {
      name: 'dropoff-details',
      label: 'Delivery',
      component: DropOffDetails,
      isComplete: (page, step) => page.address.hasAddress && page.hasShippingService,
      onEnter: (page, step) => {
        if(!page.item.price) return;
        analytics.track('CTA_BP_checkout_item_shipping_options', {
          'Item Price': page.item.price,
          'Item Name': page.item.title,
          'Item Size': page.size,
          'Payment Link': page.payment_link_url,
          'Seller Alias': page.seller,
          'Event Initiated by': 'seller'
        });
      },
      showStepMenu: false,
    },
    {
      name: 'signup',
      label: 'Sign up',
      component: SignUpSignIn,
      onEnter: (page, step) => { analytics.page('BP_checkout_buyer_sign_up') },
      onLeave: (page, step) => {
        if (!page.full_name) {
          page.setFullName(AppUser.name || '');
        }
        if (!page.phone_number) {
          page.setPhoneNumber(AppUser.phone_number || '');
        }
      },
      skipWhen: (page, step) => AppUser.isLoggedIn,
    },
    {
      name: 'info',
      label: 'Info',
      component: UserInfo,
      isComplete: (page, step) => !!(page.full_name.length && page.phone_number.match(isPhoneNumber)),
      skipWhen: (page, step) => {
        // return AppUser.isLoggedIn;
        step.isComplete(page, step)
      },
      onEnter: (page, step) => { analytics.page('BP_checkout_buyer_info') },
    },
  ]);
}
